/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
         $(window).load(function() {
          // Animate loader off screen
          $(".se-pre-con").delay('1000').fadeOut("slow");
         // $('.sticky-headers').addClass('animated bounceInDown');
        });
        // JavaScript to be fired on all pages
        $('.bubit').hover(function(){
          $(this).addClass('animated pulse');
          $(this).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
           $(this).removeClass('animated pulse');
          });
        });

        skrollr.init({
          forceHeight: false,
          easing: {
            vibrate: function(p) {
              return Math.sin(p * 10 * Math.PI);
            }
          },
          mobileCheck: function() {
                //hack - forces mobile version to be off
                return false;
            }
        });

        $('.sidebar li a').mouseenter(function(){
          chev = $(this).find('.fa-angle-right');
          $(this).find(chev).addClass('active');
        });

        $('.sidebar li a').mouseout(function(){
          isCurrent = $(this).parent().hasClass('current_page_item');

          if(isCurrent) {
            return false;
          }

          chev = $(this).find('.fa-angle-right');
          $(this).find(chev).removeClass('active');
        });

        $('.sidebar li.current_page_item a:first-child').find('.fa-angle-right').addClass('active');

        var current = window.location.href;
        $(".tag-bubble").each(function(index, el){
        	if($(el).prop("href") == current)
        	{
        		$(el).addClass("active");
        	}
        });



      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page


        $("#playVideo").click(function(e){
        	e.preventDefault();
        	$(".video-overlay").fadeIn(175);
        });

        $("#closeVideo").click(function(e){
        	e.preventDefault();
        	var content = $(".video-overlay .content").html();
        	$(".video-overlay .content").html("");
        	$(".video-overlay .content").html(content);
        	$(".video-overlay").fadeOut(175);
        });


        $('.bxslider').bxSlider({
          controls: true,
          nextText: '<i class="fa fa-angle-right"></i>',
          prevText: '<i class="fa fa-angle-left"></i>',
          auto: true,
          pause: 6000,
          autoHover: true,
          onSliderLoad: function(){
            // do funky JS stuff here
            //console.log(this);
            //$(this).find('.headline, .btn').addClass('animated fadeInUp');
          },
          onSlideBefore: function(){
            //$('.headline, .btn').removeClass('animated fadeInUp');
          },
          onSlideAfter: function(){
            //$(this).find('.headline, .btn').addClass('camein');
            // do mind-blowing JS stuff here
           // alert('A slide has finished transitioning. Bravo. Click OK to continue!');
          }
        });



        var current = "our-serv";

        // services content change
        $('.bubit, .serv-close, .serv-btns').click(function(){
          console.log(current);
          if($(this).hasClass('serv-close')){
            $(this).hide();
          } else {
            $('.serv-close').show();
          }

          targ = $(this).attr('data-bub');

          targId = '#'+targ;
          title = $(targId).attr('data-title');
          content = $(targId).attr('data-content');
          color = $(targId).attr('data-color');
          btnColor = $(targId).attr('data-btnclass');
          link = $(targId).attr('data-link');

          $('.serv-btns').css("background-color", color);
          $('.serv-it').css("background-color", color);
          $('.serv-title').html(title);
          $('.serv-content').html(content);
          $('.serv-title, .serv-content').addClass('animated bounce');
          $('.serv-link').removeClass('btn-purple btn-orange btn-green');
          $('.serv-link').addClass(btnColor);
          $('.serv-link').attr('href', link);

          $('.serv-title, .serv-content').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            $(this).removeClass('animated bounce');
          });


          next = $(this).nextUntil('bubit');
          next = $(next).attr('data-bub');
          $('.nex').attr('data-bub', next);


          prev = $(this).prevUntil('bubit');
          prev = $(prev).prevUntil('bubit');
          $('.prevs').attr('data-bub', prev);

          current = targ;

        });

        $('.serv-close').click(function(){
          $(this).hide();
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
